<template>
    <el-dialog
        title="设置登录密码"
        :visible.sync="passwordDialogVisible"
        width="550px"
        :close-on-click-modal="false">
        <el-form
            :model="passwordForm"
            :rules="passwordRules"
            ref="passwordForm"
            label-width="120px"
        >
            <el-form-item prop="passWd" size="small" label="输入密码">
                <el-input type="password"  style="width: 260px" v-model.trim="passwordForm.passWd" autocomplete="off"
                    placeholder="请输入您的密码"
                ></el-input>
            </el-form-item>
            <el-form-item prop="checkPassWd" size="small" label="确认密码">
                <el-input type="password"  style="width: 260px" v-model.trim="passwordForm.checkPassWd" autocomplete="off"
                    placeholder="请再次输入您的密码"
                ></el-input>
            </el-form-item>
            <el-form-item label="">
                <button class="cg-btn" type="button" @click="cancelSetPassword">取消</button>
                <button class="cg-btn red mgl-16" type="button" @click="submitPassword">确定</button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import { validateCombinationPwd } from '../../../utils/validate'
import { cookiesList, getCookie, removeCookie} from '../../../utils/cookies'
import { RequestRegistUser } from '../../../api/public'
import { mapGetters } from 'vuex'
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'))
            } else if (!validateCombinationPwd(value)){
                callback(new Error('密码格式不正确，请输入6-16位组合密码'))
            } else {
                callback()
            }
        }
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value != this.passwordForm.passWd){
                callback(new Error('两次密码输入不一致'))
            } else {
                callback()
            }
        }
        return {
            passwordDialogVisible: false,
            passwordForm: {
                passWd: '',
                checkPassWd: ''
            },
            passwordRules: {
                passWd: [
                    { validator: validatePass, trigger: 'change' }
                ],
                checkPassWd: [
                    { validator: validatePass2, trigger: 'change' }
                ]
            },
        }
    },
    computed: {
        ...mapGetters(['userId'])
    },
    created() {
        this.checkSetPwd()
    },
    methods: {
        submitPassword() {
            this.$refs['passwordForm'].validate((valid) => {
                if (valid) {
                    RequestRegistUser({
                        userDeviceInfo: window.navigator.userAgent,
                        passWd: this.passwordForm.passWd,
                        checkPassWd: this.passwordForm.checkPassWd,
                        userId: this.userId
                    }).then(res => {
                        console.log(res)
                        if (res.errorCode == 200) {
                            this.cancelSetPassword()
                            this.$message.success('设置密码成功')
                        } else {
                            this.$message.error(res.errorMsg || '设置密码失败')
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        // 取消设置密码
        cancelSetPassword() {
            this.passwordDialogVisible = false
            removeCookie(cookiesList.has_password)
        },
        // 检查是否要设置密码
        checkSetPwd() {
            if (getCookie(cookiesList.has_password) && getCookie(cookiesList.has_password) == 'false') {
                this.passwordDialogVisible = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>